import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useAllSheetInformationIdsBySheetIds = (sheetIds: string[]): string[] => {
  const sheetInformationDb = useSelector((state: RootState) => state.sheetInformationDb);
  const ids: string[] = [];
  sheetIds.forEach(sheetId => {
    const nominateIds = Object.keys(sheetInformationDb.sheetInformations).filter(id => sheetInformationDb.sheetInformations[id].sheetId === sheetId);
    ids.push(...nominateIds);
  })

  return ids;
}

export default useAllSheetInformationIdsBySheetIds;
